<template>
  <div class="carousel-3d-container" ref="carouselContainer" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
    <!-- 3D轮播主体 -->
    <div class="carousel-3d-wrapper">
      <div 
        class="carousel-3d-item"
        v-for="(item, index) in carouselList"
        :key="index"
        :style="getItemStyle(index)"
      >
        <img :src="item.image" :alt="item.title" class="carousel-3d-img">
        <div class="carousel-3d-caption">{{ item.title }}</div>
      </div>
    </div>

    <!-- 控制按钮 -->
    <button class="carousel-3d-btn prev" @click="prev">←</button>
    <button class="carousel-3d-btn next" @click="next">→</button>
  </div>
</template>

<script>
export default {
  name: 'Carousel3D',
  props: {
    // 轮播数据，格式：[{image: '图片地址', title: '标题'}, ...]
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    // 自动播放间隔(毫秒)
    autoPlayInterval: {
      type: Number,
      default: 3000
    },
    // 轮播项大小
    itemSize: {
      type: Object,
      default: () => ({
        width: 300,
        height: 200
      })
    },
    // 3D视角距离
    perspective: {
      type: Number,
      default: 1000
    },
    // 轮播半径
    radius: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      activeIndex: 0, // 当前激活的索引
      autoPlayTimer: null // 自动播放定时器
    }
  },
  computed: {
    // 处理后的轮播列表
    carouselList() {
      return this.list.length ? this.list : []
    },
    // 每个轮播项的角度间隔
    angleStep() {
      return 360 / this.carouselList.length
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    // 获取每个轮播项的3D样式
    getItemStyle(index) {
      // 计算当前项的旋转角度
      const angle = (index - this.activeIndex) * this.angleStep
      const radian = (angle * Math.PI) / 180
      
      return {
        width: `${this.itemSize.width}px`,
        height: `${this.itemSize.height}px`,
        transform: `rotateY(${angle}deg) translateZ(${this.radius}px)`,
        // 控制层级和透明度，让正面的元素更突出
        zIndex: angle === 0 ? 10 : Math.floor(10 - Math.abs(angle) / 10),
        opacity: angle === 0 ? 1 : 0.8 - Math.abs(angle) / 360
      }
    },
    // 上一张
    prev() {
      this.activeIndex = (this.activeIndex - 1 + this.carouselList.length) % this.carouselList.length
    },
    // 下一张
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.carouselList.length
    },
    // 开始自动播放
    startAutoPlay() {
      if (this.autoPlayInterval <= 0 || this.carouselList.length <= 1) return
      
      this.stopAutoPlay() // 先清除已有定时器
      this.autoPlayTimer = setInterval(() => {
        this.next()
      }, this.autoPlayInterval)
    },
    // 停止自动播放
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    }
  }
}
</script>

<style scoped>
.carousel-3d-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 400px;
  margin: 50px auto;
  perspective: 1500px; /* 容器的3D视角 */
}

.carousel-3d-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d; /* 保留3D变换 */
  transition: transform 0.5s ease;
}

.carousel-3d-item {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center center;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.5s ease;
}

.carousel-3d-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-3d-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 14px;
  text-align: center;
}

/* 控制按钮样式 */
.carousel-3d-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.8);
  color: #333;
  font-size: 18px;
  cursor: pointer;
  z-index: 100;
  transition: all 0.3s ease;
}

.carousel-3d-btn:hover {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}
</style>